import { resolveBusyGuardReason } from '../resolveBusyGuardReason';

export const SALES_CONTACT = '自動配車を利用したい場合はセールス (sales@logpose.co.jp) へご連絡ください。';

export type AutoDispatchAvailabilityInput = {
  isLoading: boolean;
  useAlgorithmPlanning: boolean;
  /**
   * **0 は全社表示・null はライセンス未取得**（Task 1 が `config` の有無で分ける）。
   * 混ぜると、ライセンス取得前に「配車対象の事業所を選択してください」という
   * 嘘のツールチップが出る。`strict: false` なので**型では守れない**（テスト 2 本が正本）
   */
  selectedCompanyId: number | null;
  /** controller.isBusy。実行中は再入させない（設計書 :459 の「ボタン自体」） */
  isBusy: boolean;
  /** controller の外で走る operationBulkResetting.isPending */
  isResetting: boolean;
  /**
   * 有効時のツールチップが違う（V3: 自動配車=「自動配車する」/ シナリオ=「シナリオ配車する」・
   * ActionsPresenter.tsx:157-158）。disabled の条件は同じ
   */
  kind: 'normal' | 'scenario';
};

/**
 * ツールバーの「自動配車」の disabled とツールチップを決める（設計書 :173-190 の層 2）。
 * V3Plans の ActionsPresenter.tsx:150-165 と :187-189 を写したもの。
 *
 * Why not 車両未選択をここに入れる: V3Plans は「押せるが押したあとに検査して
 * 弾く」形（:441-448）。disabled にすると挙動が変わる。層 3 は呼び出し側の担当。
 *
 * Why not isLoading 専用の文言を出す: V3 のツールチップは
 * [useAlgorithmPlanning, selected_company_id] だけで決まり、isLoading は
 * disabled にしか効かない。文言を足すと V3 と挙動が割れる。
 */
export function resolveAutoDispatchAvailability(
  input: AutoDispatchAvailabilityInput,
): { disabled: boolean; tooltip: string } {
  const busyReason = resolveBusyGuardReason({ isBusy: input.isBusy, isResetting: input.isResetting });

  const disabled = input.isLoading
    || !input.useAlgorithmPlanning
    || input.selectedCompanyId === null // ライセンス未取得。isLoading と同じ扱い
    || input.selectedCompanyId === 0
    || busyReason !== null;

  // ライセンス判定が外側（V3 の if 構造をそのまま写す）。
  // 実行中の理由は V3 に無い /map 固有の追加なので、ライセンス系より後に見る
  const enabledText = input.kind === 'scenario' ? 'シナリオ配車する' : '自動配車する';
  const tooltip = !input.useAlgorithmPlanning
    ? SALES_CONTACT
    : (input.selectedCompanyId === 0
      ? '配車対象の事業所を選択してください'
      : (busyReason ?? enabledText));

  return { disabled, tooltip };
}
